import styled from "styled-components";

export const FestivalMainCompetitionWrapper = styled.div`
  margin-top: 70px;
  width: 100%;
  position: relative;
`;

export const FestivalMainCompetitionHeader = styled.div`
  display: flex;
  width: 100%;
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  z-index: 3;
  position: relative;

  > .title {
    font-weight: 700;
    font-size: 20px;
  }
`;

export const FestivalMainCompetitionHeaderRound = styled.div<{
  isTop: boolean;
}>`
  width: 100%;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  position: absolute;
  z-index: 2;
  top: ${(p) => (p.isTop ? -20 : 280)}px;
  left: 0;
`;

export const FestivalMainCompetitionSwiperWrapper = styled.div`
  z-index: 0;
  position: relative;
`;

export const FestivalMainCompetitionSkeletonWrapper = styled.div`
  z-index: 0;
  position: relative;
  display: flex;
  gap: 12px;
`;

export const FestivalMainCompetitionSwiperItem = styled.div`
  position: relative;
  width: 100%;

  > .back {
    width: 100%;
    height: 300px;
    position: absolute;
    top: 0;
    z-index: 0;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0) 51.08%,
      #121212 85.49%
    );
  }

  > .mask {
    width: 100%;
    height: 300px;
    position: absolute;
    top: 0;
    z-index: 0;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0.7) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0) 50.18%, #121212 92.42%);
  }

  > img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }
`;

export const FestivalMainCompetitionSwiperText = styled.div`
  position: absolute;
  bottom: 60px;
  color: #fff;
  left: 12px;
  display: flex;
  gap: 2px;
  flex-direction: column;

  > .title {
    font-weight: 700;
    font-size: 18px;
  }

  > .subTitle {
    font-weight: 500;
    font-size: 12px;
  }
`;

export const FestivalMainCompetitionButton = styled.div<{ isEnd?: boolean }>`
  position: absolute;
  bottom: 0px;
  z-index: 100;
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;

  > .button {
    width: calc(100% - 82px);
    height: 48px;
    border-radius: 8px;
    background: ${(p) => (p.isEnd ? "#D9D9D9" : "#1F9F81")};
    transition: background-color 0.5s;
    box-shadow: 0px 4px 4px 0px #00000040;
    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    color: #fff;
  }
`;
